import { render, staticRenderFns } from "./zhuan2.vue?vue&type=template&id=9a3a602c&scoped=true&"
import script from "./zhuan2.vue?vue&type=script&lang=js&"
export * from "./zhuan2.vue?vue&type=script&lang=js&"
import style0 from "./zhuan2.vue?vue&type=style&index=0&id=9a3a602c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3a602c",
  null
  
)

export default component.exports